var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDownArrow(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 144,
    viewBox: "0 0 16.933325 38.100002",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(115.54 -191.75)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m-98.607 203.25v11.429l-4.1547 7.5856c-2.2851 4.1721-4.2243 7.5856-4.3094 7.5856-0.0851 0-2.0254-3.4156-4.312-7.5903l-4.1573-7.5903 0.0613-11.46 0.0613-11.46 4.1145 7.5297c2.263 4.1413 4.1674 7.5297 4.2321 7.5297 0.0647 0 1.9605-3.3726 4.213-7.4948 2.2525-4.1221 4.1305-7.4948 4.1733-7.4948 0.0428 0 0.0778 5.1433 0.0778 11.429z",
    strokeWidth: 0.25093
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownArrow);
export default __webpack_public_path__ + "static/media/downArrow.6663991c8a027ff567dbb5d5a3f3e81a.svg";
export { ForwardRef as ReactComponent };